import {ready, dqs, error_handler} from './lib/util'
import {authenticate, logout} from './lib/authentication'
import {get_message as $m} from './lib/messages'
import {show, hide, loading} from './lib/ui'
import {notify} from './lib/notifications'

import {login} from './modules/login'
import {dashboard} from './modules/dashboard'
import {upgrade_donation} from './modules/upgrade_donation'
import {update_cc} from './modules/update_cc'

const MODULES = {login, dashboard, update_cc, upgrade_donation}
let {MAINTENANCE_MODE} = process.env

const load_module = async module_name => {
  const load = MODULES[module_name]
  if(!load) {
    throw new Error(`load_module ${module_name} not found`)
  }

  hide('#app > main > section')

  try {
    const continue_flow = await load()
    if(continue_flow === false) { // a way to stop the module from loading
      return
    }
  }
  catch (error) {
    return error_handler(error)
  }

  loading('hide')

  show(
    module_name !== 'login' ? '#app > nav' : null,
    `#app > main > section#${module_name}`
  )
}

const initialise = () => {
  window.addEventListener(
    'hashchange',
    () => load_module(window.location.hash.substring(1)),
    false
  )

  const {first_name} = JSON.parse(sessionStorage.user)

  dqs('#kia_ora').innerHTML = `Kia ora ${first_name}`
  dqs('a[href="#sign_out"]').onclick = logout

  const hash = window.location.hash
  if(hash === '') {
    window.location.hash = `#${process.env.DEFAULT_MODULE || 'dashboard'}`
  }
  else {
    window.location.hash = hash
    load_module(hash.substring(1))
  }
}

ready(async () => {
  hide('#app > nav', '#app > main > section')
  dqs('body').classList.remove('invisible')
  loading('show', 'Loading, please wait a few seconds.')

  try {
    const is_authenticated = await authenticate()
    if(!is_authenticated) {
      // user is not logged in
      return load_module('login')
    }
  }
  catch (error) {
    return notify($m('ERROR_AUTH'), 'danger', () => load_module('login'))
  }

  if(MAINTENANCE_MODE === 'true') {
    return notify($m('MAINTENANCE_MODE'), 'info', () => initialise())
  }

  // user is logged in
  initialise()
})
